import {GET_AdminFillValType} from '../constants/ActionTypes'

const INIT_STATE = {
    AdminValuationType: null,
    //Message1: ''
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case GET_AdminFillValType:
                return {
                    AdminValuationType: action.body,
                    //Message1:action.msg
                  
                }
        default:
            return state;
    }
}